import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const LinkCustom = (props) => {
    const { to, target, style, className, onClick, children, href } = props;

    const LinkIsInternal = (to, target) => {
        return !((target === '_blank') || (to && ((to.indexOf('//') !== -1) || (to.indexOf('wwww.') !== -1))));
    };

    let toLink = to || href;

    let isInternal = LinkIsInternal(toLink, target);
    let link = '';
    let click = onClick || function () {};

    if (isInternal) {
        link = (
            <Link {...props} to={toLink} onClick={() => click()}>
                {children}
            </Link>
        );
    } else {
        link = (
            <a className={className} onClick={() => click()} style={style} href={toLink} target={target} rel={(target === '_blank') ? 'noopener noreferrer' : ''}>
                {children}
            </a>
        );
    }

    return link;
};

LinkCustom.propTypes = {
    className: PropTypes.string,
    target: PropTypes.string,
    to: PropTypes.string,
    href: PropTypes.string,
    style: PropTypes.object,
    onClick: PropTypes.func,
    children: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.string,
        PropTypes.object,
        PropTypes.node
    ])
};

export default LinkCustom;
